import React from 'react';
import { useParams } from 'react-router-dom';
import { Progress, Tag, Button } from 'antd';
import './ProgressTrackerInfo.scss';

// Mock data for demonstration, you would typically fetch this from an API
const mockTrainingDetails = {
  '101': {
    courseTitle: 'React Basics',
    description: 'Learn the fundamentals of React, including components, hooks, and state management.',
    progress: {
      lessonsCompleted: 15,
      totalLessons: 20,
      quizzesCompleted: 3,
      totalQuizzes: 5,
      assignmentsSubmitted: 2,
      totalAssignments: 2,
    },
    status: 'In Progress',
    dueDate: '2024-03-01',
  },
  '102': {
    courseTitle: 'Advanced JavaScript',
    description: 'Master advanced JavaScript concepts including closures, asynchronous programming, and ES6+ features.',
    progress: {
      lessonsCompleted: 10,
      totalLessons: 10,
      quizzesCompleted: 5,
      totalQuizzes: 5,
      assignmentsSubmitted: 3,
      totalAssignments: 3,
    },
    status: 'Completed',
    dueDate: '2024-02-15',
  },
  // Add other training details as needed...
};

function ProgressTrackerInfo() {
  const { trainingId } = useParams(); // Get trainingId from URL
  const training = mockTrainingDetails[trainingId]; // Use the mock data or fetch from an API

  if (!training) {
    return <div>No course found with ID: {trainingId}</div>;
  }

  return (
    <div className="training-details">
      <h1>{training.courseTitle}</h1>
      <p>{training.description}</p>

      <div className="progress-section">
        <div>Lessons Progress: <Progress percent={(training.progress.lessonsCompleted / training.progress.totalLessons) * 100} /></div>
        <div>Quizzes Progress: <Progress percent={(training.progress.quizzesCompleted / training.progress.totalQuizzes) * 100} /></div>
        <div>Assignments Progress: <Progress percent={(training.progress.assignmentsSubmitted / training.progress.totalAssignments) * 100} /></div>
      </div>

      <Tag color={new Date(training.dueDate) < new Date() ? 'red' : 'green'}>
        {new Date(training.dueDate) < new Date() ? 'Overdue' : `Due: ${training.dueDate}`}
      </Tag>

      <Button type="primary" onClick={() => console.log('Submit Training for Review')}>
        Submit for Review
      </Button>
    </div>
  );
}

export default ProgressTrackerInfo;
